import { Button } from "@mui/material";
import React from "react";

import PropTypes from "prop-types";

const propTypes = {
	onAccept: PropTypes.func,
	onClear: PropTypes.func,
	onCancel: PropTypes.func,
	resetDateTime: PropTypes.func,
	submit: PropTypes.func,
	actions: PropTypes.object,
	clearDate: PropTypes.func
};

const defaultProps = {
	resetDateTime: () => { },
	submit: () => { },
	clearDate: () => { }
};

const DatePickerActionBar = ({ onAccept, onClear, onCancel, actions, resetDateTime, submit, clearDate }) => {
	const cancel = () => {
		resetDateTime();
		onCancel();
	};
	const ok = () => {
		submit();
		onAccept();
	};

	const clear = () => {
		clearDate();
		onClear();
	};

	return (
		<div style={{ display: "flex", padding: "6px" }}>
			<div style={{ flexBasis: "50%" }}>
				{actions[0] === null ? (
					<div></div>
				) : (
					<Button variant="text" onClick={clear} data-testid="orion-components-cbcomponents-date-time-custom-components-date-picker-date-picker-action-bar-button">
						{actions[0]}
					</Button>
				)}
			</div>
			<div style={{ flexBasis: "50%" }}>
				{actions[1] && (
					<Button variant="text" onClick={cancel} data-testid="orion-components-cbcomponents-date-time-custom-components-date-picker-date-picker-action-bar-button-2">
						{actions[1]}
					</Button>
				)}
				{actions[2] && (
					<Button variant="text" onClick={ok} data-testid="orion-components-cbcomponents-date-time-custom-components-date-picker-date-picker-action-bar-button-3">
						{actions[2]}
					</Button>
				)}
			</div>
		</div>
	);
};

DatePickerActionBar.propTypes = propTypes;
DatePickerActionBar.defaultProps = defaultProps;

export default DatePickerActionBar;
